export const CLICKHOUSE_WEBSITE_URL = process.env.VUE_APP_MIX_FRONTEND_HOST
export const API_URL = process.env.VUE_APP_MIX_SERVER_API_HOST
export const API_URL_WS = process.env.VUE_APP_MIX_SERVER_API_HOST_WS
export const IS_RU_VERSION = process.env.VUE_APP_IS_RU_VERSION === 'true'
export const PHONE_CODE = IS_RU_VERSION ? '+7' : '+375'
export const PHONE_MASK = IS_RU_VERSION ? '+7 ### ### ## ##' : '+375 ## ### ## ##'
export const CURRENCY_SYMBOL = IS_RU_VERSION ? '₽' : 'BYN'

export const CHARGE_TYPE = [
  { text: 'fix', value: 0 },
  { text: '%', value: 1 },
]

export const CURRENCIES = {
  RUB: { name: 'RUB', value: 0 },
  BYN: { name: 'BYN', value: 1 },
}

export const CURRENCIES_SELECT = []

for (const v of Object.values(CURRENCIES)) {
  CURRENCIES_SELECT.push({
    text: v.name,
    value: v.value,
  })
}
